import type { UpdateTaskInput } from '@travel-planner/shared/schemas/tasks';
import type { TaskFormValues } from '../model/schema';
import { useTaskById, useUpdateTask } from '@task-manager/entities/tasks';
import { toastMutation } from '@/shared/lib';
import { Modal, ModalHeader } from '@/shared/ui';
import { TaskForm } from './task-form';

type TaskUpdateModalProps = {
  open: boolean;
  taskId: string | undefined;
  onClose: () => void;
};

export const TaskUpdateModal = ({
  open,
  taskId,
  onClose,
}: TaskUpdateModalProps) => {
  const { data: task } = useTaskById(taskId);
  const mutation = useUpdateTask();

  const handleSubmit = (values: TaskFormValues) => {
    if (!taskId) return;
    mutation.mutate(
      { ...(values as UpdateTaskInput), id: taskId } as UpdateTaskInput,
      toastMutation({ success: 'Task updated' }, { onSuccess: onClose })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader title="Edit task" onClose={onClose} />
      {task ? (
        <TaskForm
          initial={task}
          onCancel={onClose}
          onSubmit={handleSubmit}
          submitLabel="Save"
          submitting={mutation.isPending}
        />
      ) : null}
    </Modal>
  );
};
